import { Field, TextInput, TextArea, NumberInput, SectionCard } from "./_shared";

export default function EditGuarantee({ value, onChange }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  return (
    <SectionCard title="Garantia">
      <div className="space-y-5">
        <Field label="Overline"><TextInput value={value.overline} onChange={(v) => set("overline", v)} testId="guarantee-overline-input" /></Field>
        <Field label="Título"><TextInput value={value.title} onChange={(v) => set("title", v)} testId="guarantee-title-input" /></Field>
        <Field label="Descrição"><TextArea value={value.description} onChange={(v) => set("description", v)} rows={4} testId="guarantee-description-input" /></Field>
        <Field label="Dias de garantia"><NumberInput value={value.days} onChange={(v) => set("days", v)} testId="guarantee-days-input" /></Field>
      </div>
    </SectionCard>
  );
}
